module.exports = __webpack_public_path__ + "static/media/dutyFree.58f17757.svg";